// Minimal client-side normalizers to mirror backend for live preview only.
// Backend remains source of truth.

const TELEGRAM_RE = /^[A-Za-z][A-Za-z0-9_]{4,31}$/;


const stripAtAndSpaces = (value) => {
  const noSpaces = (value || '').replace(/\s+/g, '');
  return noSpaces.startsWith('@') ? noSpaces.slice(1) : noSpaces;
};

export function previewTelegram(value) {
  const cleaned = stripAtAndSpaces(value);
  if (!cleaned) throw new Error('Telegram username cannot be empty');
  if (!TELEGRAM_RE.test(cleaned)) {
    throw new Error('Invalid Telegram username. It must start with a letter, be 5–32 characters, and contain only letters, digits, or underscores.');
  }
  const display = cleaned;
  const valueNorm = cleaned.toLowerCase();
  const link = `https://t.me/${display}`;
  return { display, valueNorm, link };
}

export function previewSignal(value) {
  if (value == null) throw new Error('Signal value cannot be empty');
  const trimmed = String(value).trim();
  if (!trimmed) throw new Error('Signal value cannot be empty');
  const noSpaces = trimmed.replace(/\s+/g, '');
  const username = stripAtAndSpaces(noSpaces);
  
  if (!username) throw new Error('Signal username cannot be empty');
  return { display: username, valueNorm: username.toLowerCase(), link: `https://signal.me/#u/${username}` };
}

export function previewSocial(platform, value) {
  if (platform === 'telegram') return previewTelegram(value);
  if (platform === 'signal') return previewSignal(value);
  throw new Error('Unsupported platform');
}


